import { CoordsMessages, TranslationCoordsMessages } from "../interfaces";

export const messages: TranslationCoordsMessages = {
  [CoordsMessages.readCoordsSuccess]: "Coordenada(s) retornada(s) com sucesso",
  [CoordsMessages.noCoordFound]: "Nenhuma coordenada cadastrada",
  [CoordsMessages.readCoordsError]: "Falha ao buscar coordenada(s)"
};
